import React from 'react'
import TableHead, {
  TableHeadProps as MuiTableHeadProps,
} from '@mui/material/TableHead'
import { styled } from '@mui/material/styles'
import palette from 'core-system/Themes/palette'

const TableHeaderContainer = styled(TableHead)({
  backgroundColor: palette.secondary.purple200,
})

interface TableHeaderProps extends MuiTableHeadProps {
  children: React.ReactNode
}

const TableHeader = React.memo((props: TableHeaderProps) => {
  const { children, ...rest } = props
  return <TableHeaderContainer {...rest}>{children}</TableHeaderContainer>
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  TableHeader.displayName = 'TableHeader'
}

export default React.memo(TableHeader)
